import { useLazyQuery } from '@provision/graphql-client';
import { useCallback } from 'react';
import {
  GET_CONVERSATION_CONTEXT_FOR_MARKDOWN_EXPORT_QUERY,
  GetConversationContextForMarkdownExportQuery,
  GetConversationContextForMarkdownExportVariables,
} from './conversation-context.operations';

interface GetConversationContextInput {
  conversationId: string;
  partnerId?: number | null;
}

export const useConversationContext = () => {
  const [runConversationContextQuery, { ...rest }] = useLazyQuery<
    GetConversationContextForMarkdownExportQuery,
    GetConversationContextForMarkdownExportVariables
  >(GET_CONVERSATION_CONTEXT_FOR_MARKDOWN_EXPORT_QUERY, {
    fetchPolicy: 'no-cache',
    context: {
      ttl: 0,
    },
  });

  const getConversationContext = useCallback(
    ({ conversationId, partnerId }: GetConversationContextInput) => {
      const input: GetConversationContextForMarkdownExportVariables['input'] = {
        conversationId,
      };

      if (partnerId !== null && partnerId !== undefined) {
        input.partnerId = partnerId;
      }

      return runConversationContextQuery({
        variables: {
          input,
        },
      });
    },
    [runConversationContextQuery],
  );

  return {
    getConversationContext,
    ...rest,
  };
};
